import { Box, Typography } from '@mui/material'
import { OfferStateCountFragment } from '~/generated/graphql'

type Props = OfferStateCountFragment

export const OfferCount: React.FC<Props> = ({ entry, working, completed }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="caption">応募</Typography>
        <Typography variant="caption">{entry}件</Typography>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="caption" style={{ fontWeight: 'bold' }}>
          進行中
        </Typography>
        <Typography variant="caption" style={{ fontWeight: 'bold' }}>
          {working}件
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="caption">完了</Typography>
        <Typography variant="caption">{completed}件</Typography>
      </Box>
    </Box>
  )
}
